export default function EditButtonIcon({ width = 15, height = 15 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3125 2.9375L12.5625 5.1875M13.6875 7.4375V13.625C13.6875 13.7742 13.6282 13.9173 13.5227 14.0227C13.4173 14.1282 13.2742 14.1875 13.125 14.1875H1.875C1.72582 14.1875 1.58274 14.1282 1.47725 14.0227C1.37176 13.9173 1.3125 13.7742 1.3125 13.625V2.375C1.3125 2.22582 1.37176 2.08274 1.47725 1.97725C1.58274 1.87176 1.72582 1.8125 1.875 1.8125H8.0625M7.5 10.25H5.25V8L12 1.25L14.25 3.5L7.5 10.25Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
